const initialCamera = {
    cameraNvrLists: [],
    cameraNvrStatus: [],
    cameraNVrPermissions: {},
    changedCameraNvrStatus: [],
    loadingCameraNvr: false,
    errorsCameraNvr: {},
    cameraNvrCount: 0
}

const cameraNvrReducer = (state = initialCamera, action) => {
    switch (action.type) {
        case "GET_CAMERANVRLIST_PENDING":
        case "ADD_CAMERANVR_PENDING":
        case "UPDATE_CAMERANVR_PENDING":
        case "UPDATE_CAMERANVR_STATUS_PENDING":
        case "DELETE_CAMERANVR_PENDING":
        case "PLAY_CAMERANVR_PENDING":
        case "STOP_CAMERANVR_PENDING":
        case "GET_CAMERANVRLISTBYID_PENDING":
            return { ...state, loadingCameraNvr: true };

        case "GET_CAMERANVRLIST_FULFILLED":
            return {
                ...state,
                loadingCameraNvr: false,
                cameraNvrLists: action.payload,
                cameraNvrCount: action.cameraNvrCount,
                cameraNVrPermissions: action.permissions,
            };

        case "ADD_CAMERANVR_FULFILLED":
            return {
                ...state,
                loadingCameraNvr: false,
                changedCameraNvrStatus: action.payload,
            };

        case "UPDATE_CAMERANVR_FULFILLED":
            return {
                ...state,
                loadingCameraNvr: false,
                changedCameraNvrStatus: action.payload,
            };

        case "UPDATE_CAMERANVR_STATUS_FULFILLED":
            return {
                ...state,
                loadingCameraNvr: false,
                changedCameraNvrStatus: action.payload,
            };

        case "STOP_CAMERANVR_FULFILLED":
            return {
                ...state,
                loadingCameraNvr: false,
                changedCameraNvrStatus: action.payload,
            };

        case "GET_CAMERANVRLISTBYID_FULFILLED":
            return {
                ...state,
                loadingCameraNvr: false,
                cameraNvrLists: action.payload
            };

        case "DELETE_CAMERANVR_FULFILLED":
            return {
                ...state,
                loadingCameraNvr: false,
                changedCameraNvrStatus: action.payload
            };

        case "RESET_DELETE_CAMERANVR_STATUS":
            return {
                ...state,
                loadingCameraNvr: false,
                changedCameraNvrStatus: [],
                errorsCameraNvr: {}
            };

        case "GET_CAMERANVRLIST_REJECTED":
        case "ADD_CAMERANVR_REJECTED":
        case "UPDATE_CAMERANVR_REJECTED":
        case "UPDATE_CAMERANVR_STATUS_REJECTED":
        case "DELETE_CAMERANVR_REJECTED":
        case "PLAY_CAMERANVR_REJECTED":
        case "STOP_CAMERANVR_REJECTED":
        case "GET_CAMERANVRLISTBYID_REJECTED":
            return {
                ...state,
                loadingCameraNvr: false,
                errorsCameraNvr: action.payload
            };

        default:
            return state;
    }
}

export default cameraNvrReducer;
